/**
 * Get environment variable value
 * In Docker/production, reads from window._env_ (injected at runtime)
 * In development, reads from process.env (set at build time)
 */
export const getEnvVar = (key, defaultValue = undefined) => {
  // Check if we're in a browser environment and have runtime config
  if (typeof window !== 'undefined' && window._env_ && window._env_[key] !== undefined && window._env_[key] !== '') {
    return window._env_[key];
  }
  
  // Fallback to process.env (for development or build-time vars)
  if (process.env[key] !== undefined) {
    return process.env[key];
  }
  
  return defaultValue;
};
